import { render, staticRenderFns } from "./my-trainings.vue?vue&type=template&id=3b129412&"
import script from "./my-trainings.vue?vue&type=script&lang=js&"
export * from "./my-trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports